import React from 'react';

const errorIcon = 
    <img src="/images/admin/global/status/error.svg" width="16px" alt="" />
export default errorIcon;